export const triageDotStyles = {
  display: 'inline-flex',
  alignItems: 'center',
};
